module.exports = __webpack_public_path__ + "static/media/pizza.ae308e6a.svg";